module.exports = __webpack_public_path__ + "media/images/svg/male-3f3ac1e6bd6f2e074d3cb2595d2dca8d.svg";